if (!customElements.get('collection-menu')) {
  customElements.define(
    'collection-menu',
    class extends HTMLElement {
      constructor() {
        super();
        this.menuPopupTriggers = document.querySelectorAll('[data-menu-filter-open]')
        this.keyboardOpenedAccordions = new Set();
        this.isPointerNavigation = false;
        this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
        this.handleKeyboardFocusIn = this.handleKeyboardFocusIn.bind(this);
        this.handleKeyboardFocusOut = this.handleKeyboardFocusOut.bind(this);
      }

      connectedCallback()  {
        this.menuPopupTriggers.forEach(trigger => {
          trigger.addEventListener('click', this.openMenu.bind(this));
        });

        this.addEventListener('click', (event) => {
          const accordionHeading = event.target.closest('.accordion__heading');
          if (accordionHeading) {
            const accordion = accordionHeading.closest('.accordion');
            accordion.classList.remove('accordion--keyboard-open');
            this.keyboardOpenedAccordions.delete(accordion);
          }

          if (event.target === this || event.target.closest('[data-menu-filter-close]')) {
            this.closeMenu();
          }
        });

        this.addEventListener('focusin', this.handleKeyboardFocusIn);
        this.addEventListener('focusout', this.handleKeyboardFocusOut);
        document.addEventListener('pointerdown', this.handleDocumentPointerDown, true);
      }

      disconnectedCallback() {
        this.removeEventListener('focusin', this.handleKeyboardFocusIn);
        this.removeEventListener('focusout', this.handleKeyboardFocusOut);
        document.removeEventListener('pointerdown', this.handleDocumentPointerDown, true);
      }

      handleDocumentPointerDown() {
        this.isPointerNavigation = true;
        this.keyboardOpenedAccordions.forEach(accordion => {
          accordion.classList.remove('accordion--keyboard-open');
        });
        this.keyboardOpenedAccordions.clear();

        window.setTimeout(() => {
          this.isPointerNavigation = false;
        });
      }

      handleKeyboardFocusIn(event) {
        if (this.isPointerNavigation) return;

        const nestedLink = event.target.closest(
          '.collection-menu__child-link, .collection-menu__grandchild-link'
        );

        if (!nestedLink) return;

        let accordion = nestedLink.closest('.accordion');

        while (accordion && this.contains(accordion)) {
          accordion.classList.add('accordion--keyboard-open');
          this.keyboardOpenedAccordions.add(accordion);

          accordion = accordion.parentElement?.closest('.accordion');
        }
      }

      handleKeyboardFocusOut(event) {
        const nextFocusedElement = event.relatedTarget;

        this.keyboardOpenedAccordions.forEach(accordion => {
          if (nextFocusedElement && accordion.contains(nextFocusedElement)) return;

          accordion.classList.remove('accordion--keyboard-open');
          this.keyboardOpenedAccordions.delete(accordion);
        });
      }

      openMenu() {
        document.body.style.overflow = 'hidden'
        this.classList.add('collection-menu--active');
      }

      closeMenu() {
        document.body.style.overflow = 'auto'
        this.classList.remove('collection-menu--active');
      }
    }
  );
}
